// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { MdLockOutline } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { subsExpiredMail } from "../../services/other.sevice";
import { logoutFailure, startIsLoading } from "../../store/auth/action";
import { useNavigate, useParams } from "react-router-dom";
import { logoutUser } from "../../services/auth.service";
import { getSession } from "../../utils/sessionstore";

const SubscriptionExpiredPop = ({
  expiredpopup,
  setExpiredPopup,
  thankyoupoup,
  setThankyouPopup,
  feedbackpopup,
  setFeedbackPopup,
  thankyoumsg,
  setThankyouMsg,
  thankyousubmsg,
  setThankyouSubMsg,
}) => {
  const subscriptionHeader = useSelector((state) => state.subscriptionHeader);
  const subscriptionSubMessage = useSelector(
    (state) => state.subscriptionSubMessage
  );
  const subscriptionMessage = useSelector((state) => state.subscriptionMessage);
  const subscriptionButtonText = useSelector(
    (state) => state.subscriptionButtonText
  );
  const sessionId = getSession("session_id");
  const client_id = getSession("client_id");
  const { type }= useParams()
  const { userDetails, activedashboard, lobbyStartTime, dashboardStartTime, clientname, token } = useSelector((state) => ({
    userDetails: state.userDetails,
    activedashboard: state.activedashboard,
    lobbyStartTime: state.lobbyStartTime,
    dashboardStartTime: state.dashboardStartTime,
    clientname: state.clientname,
    token: state.token
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function logOut() {
    try {
      // dispatch(logoutRequest());
      // dispatch(logoutSuccess());
      dispatch(startIsLoading());
      await logoutUser({activedashboard, type, token, session_id: sessionId, userDetails, clientname, client_id, lobbyStartTime, dashboardStartTime, endTime: new Date()});
      navigate("/login");
    } catch (err) {
      dispatch(logoutFailure(err.message));
    }
  }

  async function sendMail() {
    try {
      if (subscriptionButtonText.trim().toLowerCase() == "activate") {
        setExpiredPopup(false);
        setThankyouMsg("Thank You");
        setThankyouSubMsg(
          "We have registered your activation request. Our Client Partner team will reach out to you regarding this."
        );
        setThankyouPopup(true);
        setFeedbackPopup(false);
      } else {
        setExpiredPopup(false);
        setThankyouPopup(false);
        setFeedbackPopup(true);
      }

      const { email, firstName, lastName, jobTitle, department, clientId } =
        userDetails;

      const response = await subsExpiredMail({
        client: clientname,
        clientId: clientId,
        email: email,
        firstname: firstName,
        lastname: lastName,
        JobDescription: jobTitle,
        Department: department,
        status: subscriptionButtonText,
      });
      // if (response.message == "sent successfully") {
      //   setLoader(false);
      // }
    } catch (e) {
      console.log("Error sendEXpMail: ", e);
    }
  }

  return (
    <div className="absolute top-0 left-0 z-[100] select-none w-screen h-screen bg-[#0000001f] filter backdrop-blur-[3px] flex flex-col justify-center items-center gap-4">
      <span className="bg-[white] w-[400px] transition-all duration-200 ease-in-out items-center flex justify-center flex-col px-8 py-4 gap-4">
        <div className="h-[60px] w-[60px] rounded-full flex justify-center items-center bg-[#F7F7F7] border border-[#E9E8E8] [box-shadow:_0px_2px_8px_0px_rgba(0,0,0,0.16)]">
          <MdLockOutline className="text-[32px] text-[#B8B8B8]" />
        </div>
        <div className="flex flex-col justify-center items-center gap-1">
          <div className="text-[16px] font-semibold text-[#333333]">
            {subscriptionHeader}
          </div>
          <div className="text-[13px] text-[#333333]" dangerouslySetInnerHTML={{ __html: subscriptionMessage }} />
          <div className="text-[11px] text-[#333333]">
            {subscriptionSubMessage}
          </div>
        </div>
        {/* Button Container */}
        <div className="flex gap-4">

          <button
            className="cursor-pointer text-[13px] font-semibold bg-[white] px-4 py-[5px] text-[#7D528B]  border border-zinc-300"
            onClick={() => logOut()}
          >
            Logout
          </button>
          {subscriptionButtonText && (
            <button
              className="cursor-pointer text-[13px] font-semibold bg-[#7D528B] px-4 py-[5px] text-[white]"
              onClick={() => sendMail()}
            >
              {subscriptionButtonText}
            </button>
          )}
        </div>
      </span>
    </div>
  );

};

export default SubscriptionExpiredPop;
